import { useState } from 'react';
import { Form, Input, Button, Row, Col, Card, Image, Spin, Checkbox, message,Layout} from 'antd';
import { useMutation } from 'react-query';
import { AndroidOutlined ,AppleOutlined } from '@ant-design/icons';
import MainHeader from '../../components/MainLayout/MainHeader';
import MyCard from '../../components/MyCard/MyCard';
import { useAuthContext } from '../../shared/context/auth-context';
import useHttpClient from '../../shared/sendRequest/useHttpClient'
import  EndPoints from '../../shared/endPoints/EndPoints.json';
import btmLogo from '../../assets/btm logo.png'

export default function Login() {
    const { login } = useAuthContext();
    const { sendRequest } = useHttpClient();
    const [forgotPassword, setForgotPassword] = useState(false);
    const [username, setUsername] = useState('')
    const [form] = Form.useForm();
    const { mutate, isLoading } = useMutation(sendRequest, {
         onSuccess: (data) => {
            if (data?.accessToken) login(data?.accessToken,form.getFieldValue('rememberMe'))
            else if(data) {message.success("Παρακαλούμε ελέγξτε το email σας")}
            form.resetFields()
        },
    });
    const { Header } = Layout;

    const layout = {
        labelCol: {
            span: 11,
        },
        wrapperCol: {
            span: 16,
        },
    };

    const onFinish = (loginData) => {
        mutate({
            endpoint: EndPoints.BASEURL + EndPoints.USER.LOGIN,
            method: 'POST',
            bodyData: loginData,
        })
    }
 
    const style = {
        title: {
            color: 'black',
            fontSize: 24,
            fontWeight: 'bold',
            marginBottom: 10
        },
        icon: {
            fontSize: '300%',
        },
        iconDirection: {
            flexDirection: 'row'
        }
    }
    const sendPassword = ()=>{    
        mutate({
            endpoint: `${EndPoints.BASEURL}${EndPoints.USERACCOUNT.FORGOTPASSWORD}?Username=${username}`,
            method: 'GET',
        })   
        setForgotPassword(!forgotPassword)
    }

    return (
        <>
            <Header style={{ backgroundColor: '#fff', position: 'fixed', width: '100% ', zIndex: 9999 ,top:0}}  >
                <MainHeader headerMenuRender={false} />
            </Header>
            <Row align="middle" style={{ minHeight: '100vh', minWidth: "100vw", backgroundColor: '#F0F0F0' }}>
                <Col xs={24} sm={24} md={24} lg={{ span: 16, push: 1 }}>
                    <Card style={{ backgroundColor: "#F0F0F0" }}>
                        <Row gutter={[16, 16]}>
                            <Col span={24} style={{ fontWeight: 'bold', fontSize: 25 ,marginTop:38 }}> Καλωσήρθες στην online εφαρμογή Short Drive!</Col>
                            <Col span={24} style={{ fontWeight: 'bold' }}> Μέσω της οnline εφαρμογής, μπορείς να δεις 24 ώρες το 24ωρο:</Col>
                            <ul><Col span={24} style={{ fontWeight: 'bold' }}><li>Αναλυτικές οδηγίες εγκατάστασης και σύνδεσης της εφαρμογής</li></Col>
                                <Col span={24} style={{ fontWeight: 'bold' }}> <li>Τα χιλιόμετρα που έχεις διανύσει</li></Col>
                                <Col span={24} style={{ fontWeight: 'bold' }}><li>Το υπόλοιπο των χιλιομέτρων που σου απομένουν</li></Col>
                                <Col span={24} style={{ fontWeight: 'bold' }}><li> Την ημερομηνία έναρξης και λήξης των διαδρομών σου</li></Col>
                            </ul>
                            <Col span={24}>
                            <Row align='middle'  >
                                <Col xs={24} sm={24} md={{span:24}} style={{ fontWeight: 'bold', fontSize:15}}>Θυμίσου ότι για την ορθή λειτουργία του Ασφαλιστικού προγράμματος Short Drive, είναι απαραίτητο</Col>
                                <Col xs={24} sm={24} md={{span:24}} style={{ fontWeight: 'bold',fontSize:15}}>να κατεβάσεις και να συνδεθείς στην εφαρμογή ShortDrive-Greece</Col>
                            </Row>
                            </Col>
                            <Col>
                                <Row>
                                    <Col xs={24} sm={24} md={{span:24}} style={{ fontWeight: 'bold'}}>Για να συνδεθείς χρειάζεται να συμπληρώσεις το όνομα χρήστη</Col>
                                    <Col xs={24} sm={24} md={{span:24}} style={{ fontWeight: 'bold'}}>και τον κωδικό πρόσβασης που θα σου στείλουμε με E-mail και SMS.</Col>
                                </Row>
                            </Col>
                            <Col style={{ flexDirection: 'column' }} xs={24} sm={24} md={24} lg={24}>
                                <Col style={style.title}>Mobile Applications</Col>
                                <Row style={style.iconDirection}>
                                    <Col push={1}><AndroidOutlined style={style.icon} onClick={() => window.open('https://play.google.com/store/apps/details?id=com.shortdrive', '_blank')} /></Col>
                                    <Col push={2}><AppleOutlined style={style.icon} onClick={() => window.open('https://apps.apple.com/us/app/shortdrive-greece/id6444884507', '_blank')} /> </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card>
                </Col>
                {isLoading ?
                 <Col   xs={24} sm={24} md={24} lg={{ span: 8, pull: 2 }}>
                    <Row justify="center">
                        <Col>
                            <Spin size='large' />
                        </Col>
                    </Row>
                    </Col>
                    :
                    <Col xs={24} sm={24} md={24} lg={{ span: 8, pull: 1 }} >
                        <Row >
                            <Col xs = {12} md={{span: 12 , offset: 3}} ><Image src={btmLogo} preview={false} width={340}  /></Col>
                            <Col span={24}> <MyCard title="Είσοδος" >
                                <Col>
                                    <Form
                                        {...layout}
                                        name="basic"
                                        form={form}
                                        onFinish={onFinish}
                                        initialValues={{
                                            remember: true,
                                        }}

                                    >
                                        <Form.Item
                                            label="Όνομα Χρήστη"
                                            name="username"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Παρακαλώ τοποθετήστε το Όνομα Χρήστη',
                                                },
                                            ]}
                                            getValueProps= {(value) => setUsername(value)}
                                        >
                                            <Input />
                                        </Form.Item>
                                        {forgotPassword ? 
                                        <>
                                            <Col xs={24} >   
                                                <Row justify='center' style={{ minHeight: '10vh'}}>                                    
                                                    <Button htmlType='submit' disabled={!username} style={{ backgroundColor: 'black', color: 'white', borderRadius: 20 }} onClick={sendPassword}>Αποστολή Κωδικού</Button>                                  
                                                </Row>
                                            </Col>
                                            <Col xs={24} >   
                                                <Row justify='center'>                                    
                                                    <Button  style={{ backgroundColor: 'black', color: 'white', borderRadius: 20, marginTop: -15}} onClick={()=>setForgotPassword(false)}>Άκυρο</Button>
                                                </Row>
                                            </Col>
                                        </>
                                        : 
                                        <>
                                        <Form.Item
                                            label="Κωδικός Πρόσβασης:"
                                            name="password"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Παρακαλώ τοποθετήστε τον Κωδικό Πρόσβασης',
                                                },
                                            ]}
                                        >
                                            <Input.Password />
                                        </Form.Item>                          
                                            <Col span={12} offset={11}>
                                                <Button type="link"  onClick={()=>{setForgotPassword(!forgotPassword)}}>Ξέχασα τον κωδικό μου</Button>
                                            </Col>
                                        <Row > 
                                        <Col xs={24}>        
                                          <Form.Item
                                            style={{ fontWeight: 'bold' }}
                                            initialValue={false}
                                            valuePropName="checked"
                                            name="rememberMe"
                                            label="Να με θυμάσαι :"
                                          >
                                            <Checkbox  checked={false} />
                                        </Form.Item>
                                        </Col>
                                        </Row>                                                                           <Form.Item>
                                            <Row justify='center'>
                                                <Button htmlType="submit" style={{ backgroundColor: 'black', color: 'white', borderRadius: 20 }}>
                                                    Σύνδεση
                                                </Button>
                                            </Row>
                                        </Form.Item>
                                        </>}    
                                    </Form>
                                </Col>
                            </MyCard></Col>
                        </Row>
                    </Col>
                }
            </Row>
        </>
    )
}